import React, { useState } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { getMeetingInfo as getMeetingInfoAction } from '../../../redux/dataSlice';
import { getTenantConfig } from '../../../config';

const customMeetingInfo = {
  'WFTXRH': {
    id: 443,
    title: 'Fellows First: The Science of MACI',
    speakers: ['Dr. Eric Strauss', 'Dr. Elan Golan', 'Dr. Benjamin Kester']
  },
  'JDWJZW': {
    id: 451,
    title: 'MACI Arthro: A Minimally Invasive Technique for an Established Treatment Option',
    speakers: ['Dr. Justin Newman', 'Dr. Michael Kuhn']
  },
  '8TM85U': {
    id: 452,
    title: 'MACI Arthro: A Minimally Invasive Technique for an Established Treatment Option',
    speakers: ['Dr. Eric McCarty', 'Dr. Lance LeClere', 'Dr. Brian Waterman']
  }
};

const { tenant } = getTenantConfig();
const isBurn = tenant === 'burn';

const VericelMeetingInfoComponent = (props) => {
  const { invalidMeetingCode, atCapacity, meetingInfo, getMeetingInfo, tenant } = props;
  const inviteCode = props.match.params.invitecode;
  const [customInfo] = useState(customMeetingInfo[inviteCode] || null);

  React.useEffect(() => {
    if (!meetingInfo) {
      getMeetingInfo(inviteCode);
    }
  }, [meetingInfo, inviteCode, getMeetingInfo]);

  React.useEffect(() => {
    // console.log('invalidMeetingCode: ', invalidMeetingCode);
    if (invalidMeetingCode || atCapacity) {
      props.history.push('/');
    }
  }, [invalidMeetingCode, atCapacity]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!meetingInfo) {
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  const { speaker, speaker2, venue } = meetingInfo;

  const sectionStyle = { marginBottom: 10 };

  return (
    <div className="meeting-info-component">
      <div className="title-text">{_.upperCase(tenant)}</div>
      <hr className="separator" />
      <div style={sectionStyle}>
        <span className="bold">Event Information: </span>
      </div>
      {!isBurn && (
        <div style={sectionStyle}>
          <span className="bold">Topic: </span>
          {customInfo ? customInfo.title : meetingInfo.title}
        </div>
      )}
      {customInfo ? (
        <ul style={{ marginTop: 0, marginBottom: 10, paddingLeft: 20 }}>
          {customInfo.speakers.map((spk, index) => (
            <li key={index}>{spk}</li>
          ))}
        </ul>
      ) : (
        <>
          <div style={sectionStyle}>
            <span className="bold">Speaker: </span>
            <br />
            {speaker.firstname} {speaker.lastname}
            {speaker.title && <span>, {speaker.title}</span>}
            <br />
            {speaker.orgname && (
              <span>
                {speaker.orgname}
                <br />
              </span>
            )}
            {speaker.city} {speaker.state}
          </div>

          {speaker2 && (
            <div style={sectionStyle}>
              <span className="bold">Speaker 2: </span>
              {speaker2.firstname} {speaker2.lastname}
              <br />
              {speaker2.title && <span>{speaker2.title}</span>}
              <br />
              {speaker2.orgname && (
                <span>
                  {speaker2.orgname},
                  <br />
                </span>
              )}
              {speaker2.city} {speaker2.state}
            </div>
          )}
        </>
      )}
      {meetingInfo.additionalspeakers.length > 0 && (
        <>
          <br />
          <div>
            <span className="bold">Additional Speakers: </span>
            {meetingInfo.additionalspeakers.map((spk, index) => (
              <div key={index} style={{ marginTop: 10 }}>
                {spk.firstname} {spk.lastname}
                {spk.title && <span>, {spk.title}</span>}
                <br />
                {spk.orgname && (
                  <>
                    <span>
                      {spk.orgname}
                      <br />
                    </span>
                  </>
                )}
                {spk.city} {spk.state}
              </div>
            ))}
          </div>
        </>
      )}
      <br />
      <div>
        <span className="bold">When: </span>
        {moment(meetingInfo.startdatetime).format('LLLL')} -{' '}
        {moment(meetingInfo.enddatetime).format('LT')} {meetingInfo.timezone}
      </div>
      <div style={sectionStyle}>
        <span className="bold">Location: </span>
        {venue.name.trim().toLowerCase() === 'virtual' ? 'Virtual Meeting' : venue.name}
        {venue.name.trim().toLowerCase() !== 'virtual' && (
          <>
            <br />
            {venue.address1}
            <br />
            {venue.address2 && (
              <span>
                {venue.address2}
                <br />
              </span>
            )}
            {venue.city && (
              <span>
                {venue.city.trim()}, {venue.state.trim()} {venue.postalcode.trim()}
              </span>
            )}
            <br />
            {venue.phone && venue.phone}
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ data }) => {
  const { meetingInfo, invalidMeetingCode, atCapacity } = data;

  return { meetingInfo, invalidMeetingCode, atCapacity };
};

export default withRouter(
  connect(mapStateToProps, { getMeetingInfo: getMeetingInfoAction })(VericelMeetingInfoComponent)
);
